import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { DocumentAutomationsComponent } from '@tv3/containers/documents/automations/document-automations.component'
import { DocumentAutomationOverlayComponent } from '@tv3/containers/documents/automations/automation-overlay/document-automation-overlay.component'
import { DocumentAutomationsOverlayComponent } from '@tv3/containers/documents/automations/automations-overlay/document-automations-overlay.component'
import { SharedModule } from '@tv3/shared/shared.module'
import { AutomationsSharedModule } from '@tv3/containers/automations/automations-shared.module'
import { TemplatesSharedModule } from '@tv3/containers/documents/templates/templates-shared.module'
import { DocumentSharedModule } from '@tv3/containers/documents/shared/document-shared.module'
import { AutomationDocumentFormComponent } from '@tv3/containers/documents/automations/automation-overlay/automation-document-form/automation-document-form.component'

const components = [
  //
  AutomationDocumentFormComponent,
  DocumentAutomationsComponent,
  DocumentAutomationOverlayComponent,
  DocumentAutomationsOverlayComponent,
]

const modules = [
  //
  SharedModule,
  DocumentSharedModule,
  TemplatesSharedModule,
  AutomationsSharedModule,
]

@NgModule({
  declarations: [...components],
  imports: [CommonModule, ...modules],
  exports: [...components, modules],
})
export class DocumentAutomationsModule {}
